import { useMutation } from "@apollo/client";
import {
    constantsData,
    identifiersData,
    namesData,
    statusTypesData,
} from "data";
import { getTracksListQuery, removeReleaseTrackMutation } from "graph";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { openAlert } from "redux/actions";
import { displayErrorHandler } from "utils";

const useRemoveReleaseTrack = (releaseId) => {
    const [exporting, setExporting] = useState(false);

    const { t } = useTranslation();

    const dispatch = useDispatch();

    const [removeReleaseTrackAction, { loading }] = useMutation(
        removeReleaseTrackMutation,
        {
            awaitRefetchQueries: true,
            refetchQueries: [
                {
                    query: getTracksListQuery,
                    variables: {
                        limit: 25,
                    orderBy: { track_num: "asc" }, //eslint-disable-line
                        page: 0,
                        where: {
                            AND: {},
                            releaseTracks: {
                                some: {
                                    releaseId: { equals: releaseId },
                                },
                            },
                        },
                    },

                },
            ],
        },
    );

    const { removeReleaseTrackPending: removeReleaseTrackPendingToastName } = namesData.toasts;

    const { toast: toastId } = identifiersData.ids;

    const removeReleaseTrack = async (id) => {
        setExporting(true);

        try {
            await removeReleaseTrackAction({
                onCompleted: () => {
                    setExporting(false);

                    dispatch(openAlert(
                        t(
                            "messages.deleteMsgs.success",
                            { entity: `${t("releases.entity")} ${t("labels.track")}` },
                        ),
                        statusTypesData.success,
                    ));
                },
                variables: {
                    where: { id },
                },
            });
        } catch (err) {
            displayErrorHandler(
                err.message === constantsData.failedToFetch ? t("messages.networkFailure") : err.message,
                dispatch,
                openAlert,
            );
        } finally {
            toast.dismiss(`${removeReleaseTrackPendingToastName}_${toastId}`);
        }
    };

    useEffect(
        () => {
            if (loading && exporting) {
                toast.info(
                    () => t(
                        "messages.removeMsgs.pending",
                        { entity: t("tracks.entity") },
                    ),
                    { toastId: `${removeReleaseTrackPendingToastName}_${toastId}` },
                );
            }
        },
        [loading, exporting], //eslint-disable-line
    );

    return { removeReleaseTrack };
};

export default useRemoveReleaseTrack;
